import React from "react";
import { useLocation } from "react-router-dom";

// Contact data for all team members
const contactsData = {
  scott: {
    name: "Scott Shuler",
    title: "Partner",
    email: "scott@bannerdaythreads.com",
    phone: "(405) 706-4894",
    address: "3550 National Dr.\nNorman, OK 73069"
  },
  eric: {
    name: "Eric Barnhart",
    title: "Partner", 
    email: "eric@bannerdaythreads.com",
    phone: "(405) 818-3277",
    address: "3550 National Dr.\nNorman, OK 73069"
  },
  quayla: {
    name: "Quayla Caldwell",
    title: "Partner",
    email: "quayla@bannerdaythreads.com", 
    phone: "(405) 532-4957",
    address: "3550 National Dr.\nNorman, OK 73069"
  },
  caleb: {
    name: "Caleb Fox",
    title: "Partner",
    email: "caleb@bannerdaythreads.com",
    phone: "(469) 363-4172", 
    address: "3550 National Dr.\nNorman, OK 73069"
  },
  nancy: {
    name: "Nancy Coleman",
    title: "",
    email: "nancy@bannerdaythreads.com",
    phone: "(325) 668-4644",
    address: "3550 National Dr.\nNorman, OK 73069"
  }
};

const BusinessCardPage = () => {
  const location = useLocation();
  
  // Extract contact name from URL path (e.g., /caleb -> caleb)
  const contactName = location.pathname.replace('/', '');
  
  // Get contact data or show 404
  const contact = contactsData[contactName?.toLowerCase()];

  // Function to generate vCard and trigger download
  const saveToContacts = () => {
    if (!contact) return;
    
    const vCard = `BEGIN:VCARD
VERSION:3.0
FN:${contact.name}
N:${contact.name.split(' ').reverse().join(';')}
ORG:Banner Day Threads
EMAIL:${contact.email}
TEL:${contact.phone}
ADR:;;${contact.address.replace('\n', ';')};;;
URL:https://bannerdaythreads.com
END:VCARD`;

    const blob = new Blob([vCard], { type: 'text/vcard' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${contact.name.replace(' ', '_')}.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };
  
  if (!contact) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-blue-600 mb-4">Contact not found</h1>
          <a 
            href="/" 
            className="text-blue-600 hover:text-blue-700 underline"
          >
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      {/* Business Card Container */}
      <div className="bg-white rounded-xl shadow-xl p-8 max-w-md w-full text-center border border-gray-200">
        {/* Company Logo/Name */}
        <h2 className="text-blue-600 font-bold mb-2 text-lg">
          BANNER DAY THREADS
        </h2>
        
        {/* Name */}
        <h1 className="text-3xl font-bold text-gray-900 mb-1">
          {contact.name}
        </h1>
        
        {/* Title */}
        {contact.title && (
          <p className="text-gray-600 mb-6 text-lg">
            {contact.title}
          </p>
        )}
        
        {/* Contact Information */}
        <div className="text-left max-w-sm mx-auto space-y-4">
          
          {/* Email */}
          <div 
            className="flex items-center p-3 rounded-lg bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors"
            onClick={() => window.location.href = `mailto:${contact.email}`}
          >
            <div className="bg-blue-600 rounded-full p-2 mr-3">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <span className="text-gray-900">
              {contact.email}
            </span>
          </div>

          {/* Phone */}
          <div 
            className="flex items-center p-3 rounded-lg bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors"
            onClick={() => window.location.href = `tel:${contact.phone}`}
          >
            <div className="bg-blue-600 rounded-full p-2 mr-3">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <span className="text-gray-900">
              {contact.phone}
            </span>
          </div>

          {/* Address */}
          <div className="flex items-start p-3 rounded-lg bg-gray-50">
            <div className="bg-blue-600 rounded-full p-2 mr-3 mt-0.5">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div className="text-gray-900 leading-relaxed">
              {contact.address.split('\n').map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          </div>

          {/* Save to Contacts Button */}
          <div className="pt-4">
            <button
              onClick={saveToContacts}
              className="w-full flex items-center justify-center p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
              Save to Contacts
            </button>
          </div>
        </div>

        {/* Back to website link */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <a 
            href="/" 
            className="text-blue-600 hover:text-blue-700 text-sm font-medium"
          >
            Visit bannerdaythreads.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default BusinessCardPage;